import React from 'react';

const About = () => {
    return (
        <div id="about" className="pt-16">
            <h2 className="text-4xl text-white font-caveat font-bold mb-8">About Me</h2>
            <p className="text-lg text-white font-titillium 
            w-10/12 lg:w-6/12 mx-auto text-left">HI! Welcome to my site.
                You will see my contact, skill or achievements on other pages.
                Here, I will just talk about myself. I was always a mediocre student.</p>
            <p className="text-lg text-white font-titillium 
            w-10/12 lg:w-6/12 mx-auto text-left mt-3">
                I may have become a frontbencher in the university,
                but I am a back-bencher from the beginning.
                I'm trying to achieve a decent overall result. </p>

            <div className="w-10/12 lg:w-5/12 mt-8 grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4 
            text-sm lg:text-lg  text-white text-left items-center justify-start mx-auto">
                <h2 className="font-bold" >Name</h2>
                <h2>Shudipta Das</h2>
                <h2 className="font-bold">Email</h2>
                <h2>shudiptod@gmail.com</h2>
                <h2 className="font-bold">Age</h2>
                <h2>24Y</h2>
                <h2 className="font-bold">Phone</h2>
                <h2>01938244498</h2>
                <h2 className="font-bold">Location</h2>
                <h2>Dhaka, Bangladesh</h2>
                <h2 className="font-bold">Availability</h2>
                <h2>Open</h2>

            </div>

        </div>
    );
};

export default About;